export const state = {
  userSurveys: [],
  isLoading: false,
  totalRecords: 0,
  userSurveyPerPage: 10000,
  activePage: 1,
};
